import { render, staticRenderFns } from "./CorportePoliciesItem.vue?vue&type=template&id=fb201ff0&"
import script from "./CorportePoliciesItem.vue?vue&type=script&lang=js&"
export * from "./CorportePoliciesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports